// extracted by mini-css-extract-plugin
export default {"formItem":"AddRemarks_formItem__Ya5V+"};